var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"mx-auto justify-center object-contain p-1 w-full"},[_c('img',{attrs:{"src":image}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }